import AbstractHybrisApi from '@/api/AbstractHybrisApi';
import type { Nullable } from '@/types/utils';

export default class ProductApi extends AbstractHybrisApi {
  find(productCode?: string, lang?: Nullable<string>) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: `/products/${productCode}?fields=FULL`,
      cache: false,
      params: {
        lang,
      },
    });
  }

  search(
    query: Nullable<string>,
    sort: string,
    currentPage: Nullable<number>,
    elevateIds: Nullable<Array<string>>,
    searchIds: Nullable<Array<string>>,
    lang: Nullable<string>,
    excludedFacets: Nullable<string>,
    facetSortOrder: Nullable<string>,
    fields = 'FULL',
    pageSize: Nullable<number>,
    startsWithUrl: Nullable<string>,
    buyAgainIds: Array<string> = [],
    abTests: Nullable<any>,
  ) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: '/products/search',
      params: {
        fields,
        query,
        sort,
        currentPage,
        pageSize,
        elevateIds,
        searchIds,
        lang,
        excludedFacets,
        facetSortOrder,
        startsWithUrl,
        buyAgainIds,
      },
      cache: false,
      abTests,
    });
  }

  suggestions(term: string, max: Nullable<number> = 10, lang: Nullable<string>, abTests: any) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: '/products/suggestions',
      params: {
        max,
        term,
        lang,
      },
      abTests,
    });
  }

  topSellers(limit = 5, lang?: Nullable<string>) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: '/products/topSellers',
      params: {
        limit,
        lang,
      },
    });
  }

  topSearchPhrases(lang?: Nullable<string>) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: '/products/topSearchPhrases',
      params: {
        lang,
      },
    });
  }

  preliminaryTotalCost(products: Array<{ code: string }>, lang?: Nullable<string>) {
    return this.request({
      method: 'post',
      version: 'v2',
      url: '/products/preliminaryTotalCost',
      params: {
        lang,
      },
      data: products,
    });
  }

  productAvailabilityInStore(productCode: string, lang: Nullable<string>, storeIds: Array<string>) {
    return this.request({
      method: 'post',
      version: 'v2',
      url: `/products/${productCode}/availability`,
      params: {
        lang,
      },
      data: storeIds,
    });
  }
}
